import { useCallback, useEffect, useRef, useState } from 'react';
import lineEndpoint from '../../../../api/services/lineEndpoint';

export const useFetchContractTypes = () => {
  const [loading, setLoading] = useState();
  const [contractTypes, setContractTypes] = useState([]);
  const isMounted = useRef(true);

  const fetchAllContractTypes = useCallback(async () => {
    setLoading(true);
    if (contractTypes.length === 0) {
      try {
        const response = await lineEndpoint.getContractType();
        if (response.status === 200) {
          if (isMounted.current) setContractTypes(response.data);
        }
      } finally {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllContractTypes().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllContractTypes]);

  return {
    loading,
    contractTypes,
  };
};